const HomePage = () => {
  const userConfig = localStorage.getItem("userConfig");
  const userConfigParse = userConfig && JSON.parse(userConfig);
  console.log(userConfigParse, "userConfigParse");
  return <div className="container home-page">Home Page!</div>;
};

export default HomePage;
